import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Miami.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Maximizing the Business Potential With Our Efficient Mobile App
              Developers in Miami
            </h2>
            <p>
              TekRevol offers diverse mobile app solutions with a profound team
              of mobile app developers in Miami. With five years of experience
              in the tech industry, we have assisted multiple businesses across
              the globe to digitize in an efficient manner leading them to
              achieve their goals.
            </p>
            <p>
              Driven by cutting-edge advancements achieved through unique
              feature customizations, we develop robust applications that create
              a difference in the market. Our well-qualified developers possess
              the highest quality skills in building versatile app solutions
              that meet the business-specific requirements of the clients.
            </p>
            <p>
              Meanwhile, our strong presence in Miami enables us to guide
              businesses toward sustainability through empowering digitization
              and efficient consulting. You are welcome to consult with us
              regarding your project and let us revolutionize your business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
